import React, { Dispatch, SetStateAction } from "react";
import styles from "./side.module.scss";
import { StateContext } from "../../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../../context/globalContext/interface";
import ProfileDetails from "../profile/profile";
import { GA_LABEL_ENUMS, triggerGAEvent } from "../../../../../constant/google-analytics/GAEvents";
import MenuPanelPopover from "../../../../reusableComponent/menuPanel/MenuPanelPopover";
import { useProfileMenuItems } from "../../../../reusableComponent/profile/useProfileMenuItems";

interface iProfileProps {
  toggleSidebar: () => void;
  setIsOpenMobileSidebar?: Dispatch<SetStateAction<boolean>>;
  isDesktopSidebarExpand?: boolean;
  mode?: "full" | "avatar";
}

export default function ProfileMenu({
  toggleSidebar,
  isDesktopSidebarExpand = true,
  mode = "full",
}: iProfileProps): JSX.Element {
  const state = React.useContext(StateContext);
  const { userInfo }: iGlobalContext = state;
  const { flatItems } = useProfileMenuItems();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    triggerGAEvent(GA_LABEL_ENUMS.sidebar_profile_click);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <div className={styles.main}>
      <ProfileDetails
        isDesktopSidebarExpand={isDesktopSidebarExpand}
        handleClick={handleClick}
        onClick={toggleSidebar}
        isLoggedIn={userInfo?.loggedIn}
        userName={userInfo?.name}
        mode={mode === "avatar" ? "avatar" : "full"}
      />
      {userInfo?.loggedIn && (
        <MenuPanelPopover
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          items={flatItems}
          placement={mode === "avatar" ? "top-start" : "right-start"}
          className={styles.profileContainer}
          paperSx={{ mr: 2 }}
        />
      )}
    </div>
  );
}
